import React from 'react'
import { Box, Text } from '@chakra-ui/react'

export default function Footer() {
    const getYear = new Date().getFullYear()
  return (
        <Box p={5} mt={10} bgColor="rgb(226, 232, 240)">
            <Text>
                &copy; { getYear } IExpense
            </Text>
        </Box>
  )
}
